import React from 'react';

import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import usePeriod from 'hooks/Meteorology/Weather/Comparator/usePeriod';
import TitleSemiBold from 'components/Typography/TitleSemiBold';

function renderMonthContent(month, shortMonth) {
  return <span>{shortMonth.toUpperCase()}</span>;
}

export default function PeriodAccordion({ modelIndex, accordionId }: {
  modelIndex: number,
  accordionId: string,
}) {
  const { getModelPeriod, changePeriod, minDate } = usePeriod({ modelIndex, accordionId });

  return (
    <Accordion.Item eventKey="period" id={accordionId}>
      <Accordion.Header>
        <TitleSemiBold>Período de seleção</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        <DatePicker
          startDate={getModelPeriod().startDate}
          endDate={getModelPeriod().endDate}
          onChange={changePeriod}
          selectsRange
          showMonthYearPicker
          renderMonthContent={renderMonthContent}
          inline
          minDate={minDate}
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
